export const shortsRailAt = (index) => {
  if (index === 0) return 0
  let pos = 0
  let rail = 0
  let gap = 6
  while (pos < 20000) {
    pos += gap
    rail += 1
    if (index === pos) return rail
    if (pos > index) return -1
    gap = gap === 6 ? 10 : 6
  }
  return -1
}

export const shortsSlice = (list = [], rail = 0, count = 8) => {
  const shorts = Array.isArray(list) ? list : []
  if (!shorts.length) return []
  const start = (rail * 6) % shorts.length
  const out = []
  for (let i = 0; i < Math.min(count, shorts.length); i += 1) {
    out.push(shorts[(start + i) % shorts.length])
  }
  return out
}
